import { Component, Input, ViewChild } from '@angular/core';
import { CustomShortenTextPipe } from '@shared/pipes/custom-shorten-text.pipe';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-overlay-panel-on-click-action',
  templateUrl: './overlay-panel-on-click-action.component.html',
  styleUrls: ['./overlay-panel-on-click-action.component.scss'],
  imports: [CustomShortenTextPipe, PopoverModule]
})
export class OverlayPanelOnClickActionComponent {

  @Input() field: any;
  @Input() maxLength: any
  @ViewChild('panel',{static:false}) panel: Popover;



  constructor() {  }

  
}
